import React, { useEffect, useState } from "react";
import "./Welcome.css";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { setLocalData } from "../../Services/localstoragedata";
import Spinner from "../Spinner/Spinner";
import OrderProgressBar from "../OrderProgressBar/OrderProgressBar";
import { apiOrderInfo } from "../QrMenuFunctions";
import Footer from "../Footer/Footer";
import BillTraceModal from "../BillTraceModal/BillTraceModal";

const Welcome = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [outletData, setOutletData] = useState([]);
  const [isOutletOpen, setIsOutletOpen] = useState(false);
  const [orderInfo, setOrderInfo] = useState([]);
  const [searchParams] = useSearchParams();

  const outletQrCodeParam = searchParams.get("outletCode");
  const rateApply = searchParams.get("rateName");
  const custId = JSON.parse(localStorage.getItem("loginDetails"))?.customerId || null;
  const custName = JSON.parse(localStorage.getItem("loginDetails"))?.customerName || null;
  const API_BASE_URL = process.env.REACT_APP_API_KEY;
  const outletQrCode = outletQrCodeParam || localStorage.getItem("outletQrCodeData");
  const orderId = localStorage.getItem("orderId") || 0;

  // Set outletCode & rateName in localStorage
  useEffect(() => {
    if (outletQrCodeParam) localStorage.setItem("outletQrCodeData", outletQrCodeParam);
    if (rateApply) localStorage.setItem("rateApply", rateApply);
  }, [outletQrCodeParam, rateApply]);

  // Fetch outlet info
  useEffect(() => {
    const fetchOutletInformation = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}QrMenu/QrMenuByOutletQrCode?outletQrCode=${outletQrCode}`
        );
        const data = response.data;
        setOutletData(data);
        setLocalData("outletdataLocal", data);
      } catch (err) {
        console.error("Error fetching outlet data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (outletQrCode) fetchOutletInformation();
  }, [outletQrCode]);

  // Determine if outlet is open
  useEffect(() => {
    if (outletData.length === 0) return;

    const { openTime, closeTime, isOpen } = outletData[0];
    if (!openTime || !closeTime || typeof isOpen === "undefined") return;

    const [openH, openM] = openTime.split(".").map(Number);
    const [closeH, closeM] = closeTime.split(".").map(Number);

    const openSeconds = openH * 3600 + openM * 60;
    const closeSeconds = closeH * 3600 + closeM * 60;

    const now = new Date();
    const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    const isOpenNow =
      openSeconds < closeSeconds
        ? currentSeconds >= openSeconds && currentSeconds <= closeSeconds
        : currentSeconds >= openSeconds || currentSeconds <= closeSeconds;

    setIsOutletOpen(isOpenNow);

    const updated = [...outletData];
    updated[0].isOpen = isOpenNow;
    localStorage.setItem("outletdataLocal", JSON.stringify(updated));
  }, [outletData]);

  const idOutlet = outletData[0]?.outletId;

  // Fetch menu-related data
  const qrMenuPageAllApis = async () => {
    try {
      const [mainCata, cataTypes, subCata, items] = await Promise.all([
        axios.get(`${API_BASE_URL}MainCata/GetMainCataByOutletId?OutletId=${idOutlet}&food=false`),
        axios.get(`${API_BASE_URL}CategoryType/GetCataTypeByOutletId?OutletId=${idOutlet}`),
        axios.get(`${API_BASE_URL}SubCategory/GetSubCataByOutletId?OutletId=${idOutlet}&food=false`),
        axios.get(
          `${API_BASE_URL}ItemMaster/GetItemsByRate?OutletId=${idOutlet}&rateApply=${localStorage.getItem("rateApply")}&food=false`
        ),
      ]);

      setLocalData("mainCategories", mainCata.data);
      setLocalData("cataTypes", cataTypes.data);
      setLocalData("subCata", subCata.data);
      setLocalData("itemMaster", items.data);
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  useEffect(() => {
    if (idOutlet) {
      qrMenuPageAllApis();
    }
  }, [idOutlet]);

  // Auto fetch order info
  useEffect(() => {
    const fetchOrder = () => apiOrderInfo(setOrderInfo);
    fetchOrder();
    const interval = setInterval(fetchOrder, 60000);
    return () => clearInterval(interval);
  }, []);

  const currentOrderStatus = orderInfo?.onlineOrderStatusDetails?.[0]?.orderStatus || 0;
  const statusMap = {
    1: "Placed",
    2: "Accepted",
    3: "Ready",
    4: "Pick Up",
    5: "Delivered",
  };
  const currentStatus = statusMap[currentOrderStatus] || "Unknown Status";

  const opnMsg = isOutletOpen ? "" : "We are Closed Now";

  if (isLoading) return <Spinner />;

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Navbar */}
        <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded">
          <div className="container-fluid">
            {outletData.map((about) => (
              <a key={about.outletId} className="navbar-brand" href="#">
                <img
                  src={about.outletlogo}
                  alt=""
                  width={60}
                  height={40}
                  className="d-inline-block align-text-center me-2 img-fluid"
                />
                <strong>{about.outletName}</strong>
              </a>
            ))}
          </div>
        </nav>

        {/* Carousel */}
        <div className="mt-2">
          {outletData[0]?.photo?.length > 0 ? (
            <div
              id="carouselExampleFade"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {outletData[0].photo.map((photo, index) => (
                  <div
                    key={photo.photoId}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <img
                      src={photo.photoUrl}
                      className="d-block w-100"
                      loading="lazy"
                      style={{ height: "250px" }}
                      alt={photo.photoName}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" />
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleFade"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" />
              </button>
            </div>
          ) : (
            <p>Loading images...</p>
          )}
        </div>

        {/* Greeting and About Us */}
        <div className="mt-4">
          <div className="d-flex">
            <h6>
              {custId ? (
                <>Welcome... <span style={{ color: "orange" }}><i>{custName}</i></span></>
              ) : (
                <>Visit Us For .......</>
              )}
            </h6>
            <div className="text-danger ms-3">{opnMsg}</div>
          </div>
          <div className="ms-2">
            {outletData.map((about) => (
              <div key={about.outletId}>
                {about.aboutUsPara1} <br /> {about.aboutUsPara2} <br /> {about.aboutUsPara3}
              </div>
            ))}
          </div>
        </div>

        {/* Order Progress */}
        {orderId > 0 && (
          <div className="p-0 mt-2">
            <div className="d-flex p-0 ms-3">
              <strong className="me-2">OrderId:</strong>
              <div className="me-4">{orderId}</div>
              {orderInfo.extraTime && (
                <div className="text-danger">{`Sorry, We are late by ${orderInfo.extraTime} Minutes`}</div>
              )}
            </div>
            <OrderProgressBar orderStatus={currentStatus} />
          </div>
        )}

        {/* Bottom Options */}
        <div className="fixed-bottom">
          <div className="AllOptionsImages">
            <Link to="/QrMenuPage">
              <button className="btn btn-">Menu</button>
            </Link>
            <Link to="/Feedback">
              <button className="btn btn-">Feedback</button>
            </Link>
            <BillTraceModal outletData={outletData} />
            <Link to="/AboutUs">
              <button className="btn btn-">About Us</button>
            </Link>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
